import { defineComponent as _defineComponent } from 'vue'
import { ref, reactive, onMounted } from 'vue'
import useLogin from '@composables/useLogin'
import usePhone from '@composables/usePhone'


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props, { expose: __expose }) {
  __expose();

const { send, isLoad } = useLogin()
const { getCodes } = usePhone()
const phoneCodes = ref([])
const formdata = reactive({
  username: null,
  password: null,
})
const countryCode = ref()

const setCountryCode = (code: string) => {
  countryCode.value = code
}

onMounted(async () => {
  const codes = await getCodes()

  phoneCodes.value = codes

  const [firstOption] = codes

  countryCode.value = firstOption.code
})

const submitForm = (sendData: object, control: any) => {
  send(formdata, control, countryCode.value)
}

const __returned__ = { send, isLoad, getCodes, phoneCodes, formdata, countryCode, setCountryCode, submitForm, ref, reactive, onMounted, get useLogin() { return useLogin }, get usePhone() { return usePhone } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})